import { type PropsWithChildren } from 'react'
import { axiosContext } from './axios-context';
import { useAuth } from '@lib/auth/use-auth.ts';
import { createApiInstance } from './create-api-instance';

export const AxiosApiProvider = ({ children }: PropsWithChildren) => {
    const { getAccessTokenSilently } = useAuth();
    const axiosInstance = createApiInstance(getAccessTokenSilently);

    return <axiosContext.Provider value={axiosInstance}>{children}</axiosContext.Provider>;
};
